package club.srams.website.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initFieldTripSchedulePage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("fieldTripSchedule.md", FrontMatterElement.Builder { addScalar("title", "Scheduled Field Trips"); }))
}

@Page("/field-trip-schedule")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun FieldTripSchedulePage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("shelton-rock-and-mineral-society-field-trip-schedule") }) {
        org.jetbrains.compose.web.dom.Text("Shelton Rock and Mineral Society Field Trip Schedule")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We’ll be doing field trips on the fourth Saturday of each month, meeting at 10:00 AM at the Shelton Matlock Park‑and‑Ride (by the Ford dealership). All locations are less than a 2‑hour drive. Here’s the plan:")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("april-25th-north-beach-port-townsend") }) {
        org.jetbrains.compose.web.dom.Text("April 25th — North Beach (Port Townsend)")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("images/field_trips/2026/map_to_North_Beach_County_Park.png", "North Beach County Park")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Focus: Sea glass, granite, jasper, other beach rocks, and abundant wildlife")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Notes: Low tide is best for collecting. Bathrooms are available nearby. Early arrival recommended for parking.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Facilities: South west corner of the park")
        }
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("images/field_trips/Field_Guide_to_Rocks_Port_Townsend.jpg", "North Beach County Park Guide")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("may-23rd-browns-creek-hoodsport-shelton") }) {
        org.jetbrains.compose.web.dom.Text("May 23rd — Browns Creek (Hoodsport/Shelton)")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Focus: Jasper (including red/green “Christmas Jasper”), quartz")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Notes: Multiple small creek access points and gravel bars make for good collecting. Wear traction boots and bring water.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Facilities: Limited")
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("june-27th-tbd") }) {
        org.jetbrains.compose.web.dom.Text("June 27th — TBD")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Focus:")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Notes:")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Facilities:")
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("july-18th-member-s-picnic") }) {
        org.jetbrains.compose.web.dom.Text("July 18th — Member's Picnic")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Focus: Food, fun, rock hounding in the East Fork Satsop River")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Notes: This for members only")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Facilities: Schafer State Park")
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("august-15th-annual-tailgate-swap") }) {
        org.jetbrains.compose.web.dom.Text("August 15th — Annual Tailgate Swap")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Focus: Rocks, rocks and more rocks.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Notes:")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Facilities: Mason County Recreation Area")
        }
    }
}
